module.exports = __webpack_public_path__ + "static/img/smartTravel.fdd2370.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ServiceCase/smartTravel.png
// module id = KOas
// module chunks = 1